export const FRAC_CALCULATION_ENABLED_FIELDS = [
  {
    fieldGuid: 'ad214d87-9463-19da-e053-c918a4889309',
    fieldName: 'GULLFAKS',
  },
] as const;

export const FRAC_CALCULATION_ENABLED_FIELD_UUIDS: ReadonlySet<string> =
  new Set(FRAC_CALCULATION_ENABLED_FIELDS.map(({ fieldGuid }) => fieldGuid));
